import {
    ORGANIZATION_SERVICE_UNSUPPORTED_MESSAGE,
    type OrganizationServiceUnsupportedError,
    type ThrowUnsupportedOrganizationServiceParams,
} from '../types';

const throwUnsupportedOrganizationService = (
    _params: ThrowUnsupportedOrganizationServiceParams
): never => {
    const error: OrganizationServiceUnsupportedError = {
        code: 'ORGANIZATION_SERVICE_DATA_VERSION_UNSUPPORTED',
        message: ORGANIZATION_SERVICE_UNSUPPORTED_MESSAGE,
    };
    throw error;
};

export default throwUnsupportedOrganizationService;
